import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1903.483 807.19c22.023 22.023 22.023 57.712 0 79.848l-677.638 677.637c-10.616 10.504-24.96 16.49-39.98 16.49h-225.88c-31.17 0-56.469-25.299-56.469-56.47v-225.88c0-15.02 5.986-29.364 16.49-39.867l677.636-677.637c22.137-22.136 57.825-22.136 79.962 0l225.879 225.879zM1668.23 962.482l115.424-115.424-146.031-146.031-115.424 115.424 146.03 146.03zm-505.744 505.743l425.895-425.895-146.03-146.03-425.895 425.894v146.031h146.03zM0 0h1468.214v564.698h-112.94V112.94H112.94v1694.092h1242.334v-225.879h112.94v338.819H0V0zm338.819 790.588V338.83h790.576v451.758H338.82zm112.94-112.94h564.697V451.77H451.758v225.88zm-112.94 451.758v-112.94h564.697v112.94H338.82zm0 225.88v-112.94h338.818v112.94H338.82z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAssignmentLine =
/*#__PURE__*/
function (_Component) {
  _inherits(IconAssignmentLine, _Component);

  function IconAssignmentLine() {
    _classCallCheck(this, IconAssignmentLine);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconAssignmentLine).apply(this, arguments));
  }

  _createClass(IconAssignmentLine, [{
    key: "render",
    value: function render() {
      return React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAssignment",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconAssignmentLine.displayName = "IconAssignmentLine";
  return IconAssignmentLine;
}(Component);

IconAssignmentLine.glyphName = 'assignment';
IconAssignmentLine.variant = 'Line';
IconAssignmentLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAssignmentLine;
export { IconAssignmentLine };